import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit  {

  public onClose: Subject<boolean> = new Subject();

  // Custom title and message support
  @Input() title: string = 'Внимание';
  @Input() message: string = 'Сигурни ли сте, че искате да извършите избраното действие?';
  @Input() confirmText: string = 'Да';
  @Input() cancelText: string = 'Не';
  @Input() confirmButtonClass: string = 'btn-primary';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {


  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  dismissModal() {
    this.onClose.next(false);
    this.activeModal.close();
  }

}
